import { styled } from 'styled-components';

export const HeaderWrap = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: 25px;
`;

export const LogoutButton = styled.button`
  background-color: #fff;
  color: #000;
  border: none;
  cursor: pointer;
  width: 100%;
  &:hover {
    color: #fff;
    background-color: red;
  }
`;
export const Logo = styled.img`
  height: 80px;
  width: 200px;
`;
export const UserTopNavbarwrap = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: end;
`;
export const UserTopNavbar = styled.div`
  padding: 5px;
  font-size: 14px;
  margin: 5px 0px;
`;
export const OverAllNavWrap = styled.div`
  display: flex;
  align-items: center;
`;
export const TrialDesWrap = styled.div`
  display: flex;
  background-color: #fff;
  padding: 8px;
  border-radius: 6px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  align-items: center;
`;
export const TrialDescription = styled.div`
  margin-left: 5px;
  color: black;
`;
